"use client";

// packages/eden-text/src/components/Text6.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var Container6 = styled.div`
  font: var(--unity-text6-legal);
  ${shared};
`;
var Text6 = ({ children, renderAs = "div", ...props }) => /* @__PURE__ */ jsx(Container6, { as: renderAs, ...props, children });
Text6.displayName = "Text6";
var Text6_default = Text6;
export {
  Text6_default as default
};
